import Rest from '../Rest'

export default class FinancialDashboardService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/financial/dashboard'

  static build(vs = null) {
    return new this(this.resource, null, vs)
  }

  getDashboard(customFilters = {}) {
    // Formato como o Grid envia: custom_filters como objeto direto nos params
    const params = {}
    if (Object.keys(customFilters).length > 0) {
      params.custom_filters = customFilters
    }
    // Passar params diretamente como segundo argumento (como o grid faz)
    return this.get('', params).then(data => {
      return data
    })
  }
}
